<template>
  <div class='custom-select' v-click-outside='close'>
    <input type='hidden' v-if='name' :name='name' :value='selected.id' />

    <div @click.prevent='open'>
      <input type='text' v-model='q' :disabled='disabled'>

      <div v-if='hasSelected' class='selected-option single-selected-option'>
        <ul>
          <li>
            <span @click.prevent="clear">x</span>
            {{ template(value) }}
          </li>
        </ul>
      </div>
    </div>

    <ul v-show='opened' class='options-list' v-scroll='scroll'>
      <li @click.prevent='select(o)' v-for='o in options' :key='o.id'>
        {{ template(o) }}
      </li>

      <li v-show='loading'>
        {{ $t('shared.loading') }}
      </li>

      <li v-show='!loading && options.length == 0'>
        {{ $t('shared.no_results') }}
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    props: {
      getter: {
        type: Function
      },
      name: {
        type: String
      },
      value: {
        type: Object,
        default: () => ({})
      },
      template: {
        type: Function,
        default: (x) => x.name
      },
      disabled: {
        type: Boolean,
        default: () => (false)
      }
    },
    created() {
      this.debouncedLoadMoreOptions = this._debounce(() => { this.loadMoreOptions() }, 500)
    },
    data() {
      return {
        q: '',
        opened: false,
        loading: false,
        noMoreResults: false,
        options: [],
        page: 0,
      }
    },
    watch: {
      q() {
        this.loading = true
        this.noMoreResults = false
        this.page = 0
        this.options = []

        this.debouncedLoadMoreOptions()
      }
    },
    computed: {
      selected() {
        return this.$props.value || {}
      },
      hasSelected() {
        return Object.keys(this.selected).length > 0
      },
    },
    methods: {
      open() {
        if (this.disabled)
          return

        this.opened = true

        if (this.options.length == 0)
          this.loadMoreOptions()
      },
      close() {
        if (!this.opened)
          return

        this.page = 0
        this.options = []
        this.opened = false
        this.noMoreResults = false
      },
      select(option) {
        this.opened = false
        this.q = ''
        this.$emit('input', option)
      },
      clear() {
        this.$emit('input', {})
      },
      loadMoreOptions() {
        this.loading = true

        this.$props.getter({ q: this.q.toLowerCase(), page: this.page + 1 }).then((data) => {
          this.loading = false
          this.page = data.meta.page

          if (data.data.length > 0)
            this.options = this.options.concat(data.data)
          else
            this.noMoreResults = true
        })
      },
      scroll(e) {
        if (this.loading || this.noMoreResults)
          return

        if (e.target.scrollTop / (e.target.scrollHeight - e.target.clientHeight) > 0.8) {
          this.loadMoreOptions()
        }
      },
    }
  }
</script>

<style lang='sass' scoped>
  @import "../../styles/select"
</style>
